<template>
  <form novalidate @submit.prevent="handleSubmit">
    <h2 class="login__title">{{ $t(`${namespace}.login`) }}</h2>
    <p class="login__text">{{ $t(`${namespace}.loginText`) }}</p>

    <FormTextField
      v-model="form.email"
      type="email"
      :label="$t(`${namespace}.form.emailLabel`)"
      :placeholder="$t(`${namespace}.form.emailPlaceholder`)"
      :disabled="submitted"
      :name="$t(`${namespace}.form.emailName`)"
      :v-validate="{ required: true, email: true }"
    />

    <FormTextField
      v-model="form.password"
      type="password"
      :label="$t(`${namespace}.form.passwordLabel`)"
      :placeholder="$t(`${namespace}.form.passwordPlaceholder`)"
      :disabled="submitted"
      :name="$t(`${namespace}.form.passwordName`)"
      v-validate="{ required: true }"
    />

    <Button
      type="submit"
      color="secondary"
      gradient
      :disabled="submitted"
      :loading="submitted"
      block
      large
    >
      {{ $t(`${namespace}.form.submitButton`) }}
    </Button>

    <div class="login__or">
      <span>{{ $t(`${namespace}.or`) }}</span>
    </div>

    <div class="text--center">
      <div class="login_disclaimer">
        {{ $t(`${namespace}.notAclientYet`) }} <a :href="smbUrl" target="_blank">{{ $t(`${namespace}.signUpNow`) }}!</a>
      </div>

      <div class="mt-1">
        <a
          href="https://99app.com/legal/termos/motorista"
          :title="$t(`${namespace}.termsOfUse`)"
          target="_blank"
        >
          {{ $t(`${namespace}.termsOfUse`) }}
        </a>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import sapConcur from '@/services/modules/sapConcur'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'LoginForm',
  computed: {
    smbUrl () {
      return process.env.NODE_ENV === 'production'
        ? 'https://corp.99app.com/cadastro'
        : 'https://b2b-onboarding.staging.99taxis.com'
    },
    routeQueryParams () {
      return this.$route.query
    }
  },
  data () {
    return {
      namespace: 'Components.LoginForm',
      passwordInputType: 'password',
      form: {
        email: null,
        password: null
      },
      submitted: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    tooglePasswordVisibility (event) {
      if (event.target.classList.contains('v-icon')) {
        this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password'
      }
    },

    changeSubmittedValue (boolean = true) {
      this.submitted = boolean
    },

    isValidRequest (res) {
      return Boolean(res && res.data && res.data.valid)
    },

    showErrorMessage (res) {
      const reason = res?.data?.reasons && res.data.reasons[0]

      this.showAlert({
        type: 'error',
        message: reason || this.$t('Common.genericError')
      })
    },

    async handleSubmit () {
      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      this.changeSubmittedValue(true)

      try {
        const { email, password } = this.form
        const { id, requestToken } = this.routeQueryParams
        const formData = new FormData()
        const user = await sapConcur.login({ email, password })

        formData.append('id', id)
        formData.append('tokenRequest', requestToken)

        if (!this.isValidRequest(user)) {
          this.showErrorMessage(user)
          this.changeSubmittedValue(false)
          return
        }

        const token = user.data.content

        try {
          const res = await sapConcur.create(formData, token)

          if (!this.isValidRequest(res)) {
            this.showErrorMessage(res)
            this.changeSubmittedValue(false)
            return
          }

          this.$emit('toggleContainer')
        } catch (error) {
          this.showErrorMessage(error)
          catchError(error)
        }
      } catch (error) {
        this.showErrorMessage(error)
        catchError(error)
      }

      this.changeSubmittedValue(false)
    }
  }
}
</script>
